import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledButtonGroup = styled(ButtonGroup)`
  width: fit-content;
  white-space: nowrap;

  ${borderRadius.r3}
  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2}
  }
`;

export const Wrapper = styled.div<{ $active: boolean, $compactMode: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: ${({ $compactMode }) => $compactMode ? '0 7px' : '0'};

  svg {
    fill: ${({ $active }) =>
    $active ? 'var(--text-primary)' : 'var(--text-soft)'};

    path {
      fill: ${({ $active }) =>
    $active ? 'var(--text-primary)' : 'var(--text-soft)'};
    }
  }
`;
